<template>
  <div class="patientTag">
    <div class="patientTag_page">
      <div class="page_entry">
        <div class="page_entry_title">标签分类</div>
        <div class="page_entry_search">
          <el-input
            v-model.trim="categoryMap.search"
            placeholder="搜索标签分类"
            prefix-icon="el-icon-search"
            clearable
            @input="categorySearch">
          </el-input>
        </div>
        <div class="page_entry_list">
          <div v-for="category in categoryMap.list" :key="category.categoryId" :class="{ 'page_entry_item': true, 'active': category.categoryId === categoryMap.activeId }" @click="categorySelect(category.categoryId)">
            <div class="page_entry_left">
              <div class="page_entry_name">{{ category.categoryName }}</div>
            </div>
            <div class="page_entry_action">
              <span class="el-icon-edit-outline page_entry_action_btn" @click.stop="categoryOpen(category.categoryId)"></span>
              <span class="el-icon-delete page_entry_action_btn" @click.stop="categoryDelete(category)"></span>
            </div>
          </div>
        </div>
        <div class="page_entry_btn" @click="categoryOpen()"><i class="el-icon-plus"></i> 新增标签分类</div>
      </div>
      <div class="page_entry">
        <div class="page_entry_title">标签</div>
        <div class="page_entry_search">
          <el-input
            v-model.trim="tagMap.search"
            placeholder="搜索标签"
            prefix-icon="el-icon-search"
            clearable
            @input="tagSearch">
          </el-input>
        </div>
        <div class="page_entry_list">
          <div v-for="tag in tagMap.list" :key="tag.labelId" :class="{ 'page_entry_item': true, 'tag_active': tag.labelId === tagMap.activeId }" @click="tagSelect(tag.labelId)">
            <div class="page_entry_left">
              <div class="page_entry_name">{{ tag.labelName }}</div>
            </div>
          </div>
        </div>
        <div v-if="categoryMap.activeId" class="page_entry_btn" @click="tagOpen()"><i class="el-icon-plus"></i> 新增标签</div>
      </div>
      <div class="page_info">
        <div class="page_info_header">
          <div class="page_info_header_title"></div>
          <div v-show="tagMap.activeId" class="page_info_action">
            <el-button type="primary" @click="tagOpen(tagInfo.labelId)">编辑</el-button>
            <el-button type="danger" plain @click="tagDelete">删除</el-button>
          </div>
        </div>
        <div v-show="tagMap.activeId" class="page_info_list">
          <div class="page_info_row">
            <div class="page_info_row_label">名称</div>
            <div class="page_info_row_value">{{ tagInfo.labelName }}</div>
          </div>
          <div class="page_info_row">
            <div class="page_info_row_label">所属分类</div>
            <div class="page_info_row_value">{{ tagInfo.categoryName }}</div>
          </div>
          <div class="page_info_row">
            <div class="page_info_row_label">标签类型</div>
            <div class="page_info_row_value">{{ tagInfo.labelType == '1' ? '手动标记' : '自动标记' }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 分类编辑 -->
    <el-dialog
      :title="categoryEditMap.form.categoryId ? '编辑分类' : '新增分类'"
      :visible.sync="categoryEditMap.visible"
      width="400px"
      :before-close="categoryClose"
      :close-on-click-modal="false">
      <el-form ref="categoryForm" :model="categoryEditMap.form" :rules="categoryEditMap.rules">
        <el-form-item label="分类名称" prop="categoryName">
          <el-input v-model.trim="categoryEditMap.form.categoryName" placeholder="请输入分类名称" maxlength="20" />
        </el-form-item>
      </el-form>
      <!-- 操作按钮 -->
      <div slot="footer">
        <el-button @click="categoryClose">取 消</el-button>
        <el-button type="primary" @click="categoryConfirm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 标签编辑 -->
    <el-dialog
      :title="tagEditMap.form.categoryId ? '编辑标签' : '新增标签'"
      :visible.sync="tagEditMap.visible"
      width="400px"
      :before-close="tagClose"
      :close-on-click-modal="false">
      <el-form ref="tagForm" :model="tagEditMap.form" :rules="tagEditMap.rules">
        <el-form-item class="tag_form-item" label="标签名称" prop="labelName">
          <el-input v-model.trim="tagEditMap.form.labelName" placeholder="请输入标签名称" maxlength="10" />
        </el-form-item>
        <el-form-item class="tag_form-item" label="标签类型" prop="labelType">
          <el-select v-model="tagEditMap.form.labelType" class="tag_type_select" placeholder="请选择标签类型">
            <el-option
              v-for="item in tagEditMap.typeList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 操作按钮 -->
      <div slot="footer">
        <el-button @click="tagClose">取 消</el-button>
        <el-button type="primary" @click="tagConfirm">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import { debounce } from '@/utils/validateBase'
  import req from '@/utils/request'
  export default {
    name: 'patientTag',
    data() {
      return {
        categoryMap: {
          search: '',
          activeId: '',
          list: []
        },
        tagMap: {
          search: '',
          activeId: '',
          list: []
        },
        tagInfo: {
          categoryId: '',
          categoryName: '',
          labelId: '',
          labelName: '',
          labelType: ''
        },
        categoryEditMap: {
          visible: false,
          rules: {
            categoryName: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }]
          },
          form: {
            categoryId: '',
            categoryName: '',
          }
        },
        tagEditMap: {
          visible: false,
          typeList: [
            { name: '手动标记', value: '1' }
          ],
          rules: {
            labelName: [{ required: true, message: '标签名称不能为空', trigger: 'blur' }],
            labelType: [{ required: true, message: '请选择标签类型', trigger: 'change' }]
          },
          form: {
            categoryId: '',
            labelId: '',
            labelName: '',
            labelType: '1'
          }
        }
      }
    },
    created () {
      this.getCategoryList()
    },
    methods: {
      async getCategoryList () {
        const res = await req.get('/patient/manuallabel/category/list', { categoryName: this.categoryMap.search })
        if (res.code === 200) {
          this.categoryMap.list = res.data || []

          if (this.categoryMap.activeId && !this.categoryMap.list.some(v => { return v.categoryId === this.categoryMap.activeId })) {
            this.categoryMap.activeId = ''
            this.tagMap.activeId = ''
            this.tagMap.list = []
            this.tagInfo = {
              categoryId: '',
              categoryName: '',
              labelId: '',
              labelName: '',
              labelType: ''
            }
          }
        }
      },

      categorySearch: debounce(function () {
        this.tagMap.search = ''
        this.getCategoryList()
      }, 300),

      categorySelect (id = '') {
        if (this.categoryMap.activeId !== id) {
          this.categoryMap.activeId = id
          this.tagMap.search = ''
          this.tagMap.activeId = ''
          this.tagInfo = {
            categoryId: '',
            categoryName: '',
            labelId: '',
            labelName: '',
            labelType: ''
          }
          this.getTagList()
        }
      },

      categoryDelete (category) {
        this.$confirm(`确定要删除分类「${category.categoryName}」吗?删除分类后，标签分类下的标签都会被删除。`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await req.post('/patient/manuallabel/category/remove', [category.categoryId])
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getCategoryList()
          }
        }).catch(() => {})
      },

      async categoryOpen (id = '') {
        if (id) {
          this.categoryEditMap.form.categoryId = id
          const res = await req.get('/patient/manuallabel/category/getDetail', { categoryId: id })
          if (res.code === 200) {
            this.categoryEditMap.form.categoryName = res.data.categoryName
          }
        }
        this.categoryEditMap.visible = true
      },

      categoryClose () {
        this.categoryEditMap.visible = false
        this.categoryEditMap.form = {
          categoryId: '',
          categoryName: ''
        }
        this.$refs.categoryForm.clearValidate()
      },

      async categoryConfirm () {
        this.$refs.categoryForm.validate(async valid => {
          if (valid) {
            let res =  null
            if (this.categoryEditMap.form.categoryId) {
              res = await req.post('/patient/manuallabel/category/edit', this.categoryEditMap.form)
            } else {
              res = await req.post('/patient/manuallabel/category/add', this.categoryEditMap.form)
            }
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.categoryClose()
              this.getCategoryList()
            }
          }
        })
      },

      async getTagList () {
        const res = await req.get('/patient/manuallabel/list', {
          categoryId: this.categoryMap.activeId,
          labelName: this.tagMap.search
        })
        if (res.code === 200) {
          this.tagMap.list = res.data || []

          if (this.tagMap.activeId && !this.tagMap.list.some(v => { return v.labelId === this.tagMap.activeId })) {
            this.tagMap.activeId = ''
            this.tagInfo = {
              categoryId: '',
              categoryName: '',
              labelId: '',
              labelName: '',
              labelType: ''
            }
          }
        }
      },

      tagSearch: debounce(function () {
        this.getTagList()
      }, 300),

      async getTagInfo () {
        if (this.tagMap.activeId) {
          const res = await req.get('/patient/manuallabel/getDetail', { labelId: this.tagMap.activeId })
          if (res.code === 200) {
            this.tagInfo.categoryId = res.data.categoryId
            this.tagInfo.categoryName = res.data.categoryName
            this.tagInfo.labelId = res.data.labelId
            this.tagInfo.labelName = res.data.labelName
            this.tagInfo.labelType = res.data.labelType
          }
        }
      },

      tagSelect (id = '') {
        if (this.tagMap.activeId !== id) {
          this.tagMap.activeId = id
          this.getTagInfo()
        }
      },

      tagDelete () {
        this.$confirm(`确定要删除标签「${this.tagInfo.labelName}」吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await req.post('/patient/manuallabel/remove', [this.tagInfo.labelId])
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getTagList()
          }
        }).catch(() => {})
      },

      async tagOpen (id = '') {
        this.tagEditMap.form.categoryId = this.categoryMap.activeId
        if (id) {
          this.tagEditMap.form.labelId = id
          const res = await req.get('/patient/manuallabel/getDetail', { labelId: this.tagEditMap.form.labelId })
          if (res.code === 200) {
            this.tagEditMap.form.labelName = res.data.labelName
            this.tagEditMap.form.labelType = res.data.labelType
          }
        }
        this.tagEditMap.visible = true
      },

      tagClose () {
        this.tagEditMap.visible = false
        this.tagEditMap.form = {
          categoryId: '',
          labelId: '',
          labelName: '',
          labelType: '1'
        }
        this.$refs.tagForm.clearValidate()
      },

      async tagConfirm () {
        this.$refs.tagForm.validate(async valid => {
          if (valid) {
            let res =  null
            if (this.tagEditMap.form.labelId) {
              res = await req.post('/patient/manuallabel/edit', this.tagEditMap.form)
            } else {
              res = await req.post('/patient/manuallabel/add', this.tagEditMap.form)
            }
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.tagClose()
              this.getTagList()
              this.getTagInfo()
            }
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .patientTag {
    width: 100%;
    height: 100%;
  }

  .patientTag_page {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    border: 1px solid #D3D3D5;
    border-radius: 2px;
  }

  .page_entry {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 230px;
    height: 100%;
    border-left: 1px solid #D3D3D5;
    border-right: 1px solid #D3D3D5;
  }

  .patientTag_page .page_entry:first-child {
    border-left: none;
  }

  .page_entry + .page_entry {
    margin: 0 0 0 8px;
  }

  .page_entry_title {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 40px;
    font-size: 14px;
    color: #1f2329;
    background-color: #F0F1F3;
    border-bottom: 1px solid #D3D3D5;
  }

  .page_entry_search {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 6px;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #D3D3D5;
  }

  .page_entry_list {
    flex-grow: 1;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .page_entry_item {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    min-height: 40px;
    border-bottom: 1px solid #D3D3D5;
    cursor: pointer;
  }

  .page_entry_item.tag_active {
    background-color: #e8f4ff;
  }

  .page_entry_left {
    flex-grow: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .page_entry_name {
    flex-grow: 1;
    line-height: 20px;
    font-size: 14px;
    color: #1f2329;
  }

  .page_entry_item.active .page_entry_name {
    color: #1890ff;
  }

  .page_entry_item.tag_active .page_entry_name {
    color: #1890ff;
  }

  .page_entry_action {
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0 0 0 12px;
  }

  .page_entry_action_btn {
    font-size: 14px;
    color: #1f2329;
  }

  .page_entry_action_btn + .page_entry_action_btn {
    margin: 0 0 0 6px;
  }

  .page_entry_item.active .page_entry_action_btn {
    color: #1890ff;
  }

  .page_entry_btn {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 36px;
    font-size: 14px;
    color: #1f2329;
    border-top: 1px solid #D3D3D5;
    cursor: pointer;
  }

  .page_info {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 0 0 10px;
    height: 100%;
    border-left: 1px solid #D3D3D5;
  }

  .page_info_header {
    flex-shrink: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 40px;
    background-color: #f0f1f3;
    border-bottom: 1px solid #d3d3d5;
  }

  .page_info_header_title {
    font-size: 14px;
    color: #1f2329;
  }

  .page_info_action {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .page_info_list {
    flex-grow: 1;
    width: 100%;
    min-height: 0px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .page_info_row {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 96px 1fr;
    width: 100%;
    min-height: 40px;
    background-color: #f7f8f9;
    border-bottom: 1px solid #d3d3d5;
  }

  .page_info_row_label {
    flex-shrink: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 96px;
    padding: 0 12px;
    font-size: 14px;
    color: #1f2329;
    border-right: 1px solid #d3d3d5;
  }

  .page_info_row_value {
    flex-grow: 1;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 12px;
    line-height: 20px;
    font-size: 14px;
    color: #1f2329;
  }

  .tag_form-item {

  }

  .tag_form-item /deep/.el-form-item__label {
    float: none;
  }

  .tag_type_select {
    width: 100%;
  }
</style>